import { Injectable } from '@angular/core';
import { ApiCommon } from '@shared/apis/common';
import { Observable } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class ProductApi extends ApiCommon {

  getSerialInfo(serialNo: any): Observable<any> {
    return this.apiServer.product.getSerialInfo(serialNo);
  }

  getModelInfo(modelCode: any): Observable<any> {
    return this.apiServer.product.getModelInfo(modelCode);
  }

  getSimpleSymptoms(productType: string): Observable<any> {
    return this.apiServer.product.getSimpleSymptoms(productType);
  }

  getSymptomsDescription(productType): Observable<any> {
    return this.apiServer.product.getSymptomsDescription(productType);
  }

  getFmrIdSearch(params: any): Observable<any> {
    return this.apiServer.product.getFmrIdSearch(params);
  }

  getProductHistory(params: any): Observable<any> {
    return this.apiServer.product.getProductHistory(params);
  }
}
